import $ from "jquery";

// The majority of this is legacy,
// I've updated the arguments for sanity
export function applySortingRelatedIconsAndSetHiddenFields({headerElement, elements, sortField, callback}){
  const icon = headerElement.find("i");
  if(icon.hasClass('fa-sort-asc')){
    icon.removeClass('fa-sort-asc');
    icon.addClass("fa-sort-desc");
    elements.sortFieldHiddenInput.val(sortField);
    elements.sortTypeHiddenInput.val('desc');
    callback();
  }else{
    icon.removeClass("fa-sort-desc");
    headerElement.find("i").addClass("fa-sort-asc");
    elements.sortFieldHiddenInput.val(sortField);
    elements.sortTypeHiddenInput.val('asc');
    callback();
  }
  const otherIcons = headerElement.parent().siblings().find("i");
  otherIcons.removeClass("fa-sort-asc fa-sort-desc");
  otherIcons.addClass("fa-sort");
};


// WEBPACK FOOTER //
// ./src/utilities/filtersLegacy/index.js